/**
 * Avant-Garde Horology - Luxury Timepiece Presentation Engine
 * Shopify OS 2.0 Theme JS (Crash-Proof Architecture & Real AJAX Cart Engine)
 */
(function() {
  'use strict';

  function assetUrl(filename) {
    if (!filename) return '';
    if (filename.startsWith('http://') || filename.startsWith('https://') || filename.startsWith('//') || filename.startsWith('data:')) {
      return filename;
    }
    if (window.THEME_ASSETS && window.THEME_ASSETS[filename]) {
      return window.THEME_ASSETS[filename];
    }
    return filename;
  }

  function formatMoney(cents) {
    if (cents === null || cents === undefined) return '₹0.00';
    if (typeof cents === 'string' && cents.includes('₹')) return cents;
    const num = Number(cents) / 100;
    return '₹' + num.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  // 4 Distinct Luxury Watches (Paddock 74 is first)
  const BASE_PRODUCTS = [
    {
      id: "cypher-paddock",
      title: "PADDOCK 74 <span class='model-spec'>CHRONO SPECIAL™</span>",
      reference: "REF. CYP-PAD-74 LIMITED EDITION",
      campaignTag: "Grand Prix Precision",
      price: "₹9,974.00",
      priceCents: 997400,
      heroImg: assetUrl("cypher-paddock.png"),
      hexColor: "#6a1a24",
      detailTheme: "theme-paddock",
      discoverLabel: "DISCOVER PADDOCK 74",
      storyHeadline: "BIGGER, FASTER,<br/>LOUDER",
      storyText: "Engineered for the high-octane adrenaline of grand prix motorsport. Built from aerospace-grade 316L paddock steel with a multi-tiered sunburst racing dial, split-second chronograph sub-dials, and tachymeter bezel. Designed to withstand intense g-forces on track day and deliver unyielding mechanical distinction.",
      storyBadge: "🏁 GRAND PRIX MOTORSPORT CALIBER",
      features: [
        { title: "HIGH-BEAT CHRONO CALIBER", desc: "Precision mechanical chronograph with instant column-wheel pushers" },
        { title: "ULTRA RUGGED 316L BUILD", desc: "Brushed paddock steel case resistant to shock, vibrations & corrosion" },
        { title: "EXTENDED POWER RESERVE", desc: "High-torque balance spring delivering 48 hours of autonomous running" }
      ],
      macroImg: assetUrl("cypher-paddock-74-side-profile-crown-pushers-black-strap.png"),
      lifestyleImg: assetUrl("cypher-paddock-5.webp"),
      wristCaseSize: "41.0MM",
      wristCaseDesc: "(48.5MM Lug-to-Lug)",
      cardVariant: "IN RACING BURGUNDY & BLACK",
      gallery: [
        { src: assetUrl("cypher-paddock.png"), label: "Front Dial", desc: "Classic Dial View" },
        { src: assetUrl("cypher-paddock-74-side-profile-crown-pushers-black-strap.png"), label: "3/4 Profile", desc: "Angle Perspective" },
        { src: assetUrl("cypher-paddock-3.webp"), label: "Case & Bezel", desc: "Sculpted Lugs View" },
        { src: assetUrl("cypher-paddock-4.webp"), label: "Super-LumiNova", desc: "Night Glow Caliber" },
        { src: assetUrl("cypher-paddock-5.webp"), label: "On Wrist", desc: "Lifestyle Exhibition" },
        { src: assetUrl("CypherPaddock-6.webp"), label: "Macro Detail", desc: "Precision Sub-dials" },
        { src: assetUrl("cypher-paddock-74-side-profile-crown-pushers-black-strap.png"), label: "Side Profile", desc: "Crown & Pushers Detail" },
        { src: assetUrl("CypherBackCase-Black.png"), label: "Exhibition Caseback", desc: "Open Mechanical Back" }
      ],
      specs: [
        ["Movement", "High-Beat Mechanical Chronograph Caliber"],
        ["Power Reserve", "48 Hours, dual-directional automatic rotor"],
        ["Case Dimensions", "41 mm circular, 316L Brushed Paddock Steel"],
        ["Dial Structure", "Sunburst racing dial with dual sub-dials & tachymeter scale"],
        ["Water Resistance", "10 bar (~100 metres / 330 feet)"],
        ["Strap", "Perforated rally leather strap with crimson saddle stitching"]
      ]
    },
    {
      id: "avocado",
      title: "AVOCADO AUTOMATIC <span class='model-spec'>TONNEAU SPECIAL™</span>",
      reference: "REF. AVO-01 SPECIAL EDITION",
      campaignTag: "Artisanal Horology",
      price: "₹4,999.00",
      priceCents: 499900,
      heroImg: assetUrl("imgi_293_Avocado_3.png"),
      hexColor: "#3d5423",
      detailTheme: "theme-avocado",
      discoverLabel: "DISCOVER AVOCADO",
      storyHeadline: "WHIMSICAL, MECHANICAL,<br/>ICONIC",
      storyText: "A daring statement in avant-garde Haute Horlogerie. The Avocado Automatic challenges conventional timepiece design with a sculptural 316L tonneau case and an artisanal multi-layered textured dial inspired by organic geometry. Swiss mechanical movement meets bold artistic vision.",
      storyBadge: "🥑 HAUTE HORLOGERIE TONNEAU",
      features: [
        { title: "MECHANICAL JUMPING HOUR", desc: "Proprietary Swiss automatic caliber with jumping disc aperture" },
        { title: "CURVED TONNEAU ERGONOMICS", desc: "Contoured 42 x 34 mm case that hugs the natural curve of the wrist" },
        { title: "HAND-LACQUERED GUILLOCHÉ", desc: "Individually rendered textured guilloché dial with anti-reflective sapphire" }
      ],
      macroImg: assetUrl("avocado_macro.png"),
      lifestyleImg: assetUrl("imgi_293_Avocado_3.png"),
      wristCaseSize: "42 x 34MM",
      wristCaseDesc: "(Tonneau Contour)",
      cardVariant: "IN OLIVE GREEN & STEEL",
      gallery: [
        { src: assetUrl("imgi_293_Avocado_3.png"), label: "Front Dial", desc: "Front View 1" },
        { src: assetUrl("imgi_293_Avocado_3.png"), label: "Perspective Angle", desc: "Angle View 2" },
        { src: assetUrl("imgi_293_Avocado_3.png"), label: "Full Profile", desc: "Profile View 3" }
      ],
      specs: [
        ["Movement", "Automatic mechanical jumping hour caliber"],
        ["Power Reserve", "42 Hours, single high-torque mainspring"],
        ["Case Dimensions", "42 x 34 mm Tonneau, 316L Stainless Steel"],
        ["Dial Structure", "Multi-layered textured guilloché avocado pip"],
        ["Water Resistance", "5 bar (~50 metres / 165 feet)"],
        ["Strap", "Handcrafted Italian calfskin in olive leather"]
      ]
    },
    {
      id: "moon",
      title: "SLEEPING ON THE MOON <span class='model-spec'>CELESTIAL 40MM</span>",
      reference: "REF. LUNAR-04 SPECIAL EDITION",
      campaignTag: "Drifting in Orbit",
      price: "₹4,999.00",
      priceCents: 499900,
      heroImg: assetUrl("imgi_51_sleepmoon4-30.png"),
      hexColor: "#1b426b",
      detailTheme: "theme-moon",
      discoverLabel: "DISCOVER MOON",
      storyHeadline: "DRIFTING IN<br/>ZERO GRAVITY",
      storyText: "A celestial poem worn on the wrist. Sleeping on the Moon features a photorealistic 3D lunar crater dial with a floating astronaut who drifts through the celestial night sky. Powered by a high-beat automatic movement with a 24-hour day/night lunar disc.",
      storyBadge: "🌙 24-HOUR CELESTIAL DISC",
      features: [
        { title: "24-HOUR CELESTIAL ROTOR", desc: "Rotating lunar disc reflecting real-time orbital progression" },
        { title: "MIRROR-POLISHED 316L STEEL", desc: "40mm circular case finished with jewelers mirror polish" },
        { title: "48-HOUR DUAL ROTOR", desc: "Bi-directional winding mechanism ensuring flawless timekeeping" }
      ],
      macroImg: assetUrl("moon_macro.png"),
      lifestyleImg: assetUrl("imgi_51_sleepmoon4-30.png"),
      wristCaseSize: "40.0MM",
      wristCaseDesc: "(47.0MM Lug-to-Lug)",
      cardVariant: "IN CELESTIAL BLUE & STEEL",
      gallery: [
        { src: assetUrl("imgi_51_sleepmoon4-30.png"), label: "Front Dial", desc: "Front View 1" },
        { src: assetUrl("imgi_51_sleepmoon4-30.png"), label: "Perspective Angle", desc: "Angle View 2" },
        { src: assetUrl("imgi_51_sleepmoon4-30.png"), label: "Full Profile", desc: "Profile View 3" }
      ],
      specs: [
        ["Movement", "Swiss Automatic with 24-hour celestial rotating disc"],
        ["Power Reserve", "48 Hours, dual-direction winding rotor"],
        ["Case Dimensions", "40 mm circular, 316L Mirror-Polished Steel"],
        ["Dial Topography", "Photorealistic lunar crater relief with floating astronaut"],
        ["Water Resistance", "5 bar (~50 metres / 165 feet)"],
        ["Strap", "Midnight black genuine leather with matching stitching"]
      ]
    },
    {
      id: "steaks",
      title: "HIGH STEAKS UFO BEAM <span class='model-spec'>ABDUCTION 40MM</span>",
      reference: "REF. UFO-53 LIMITED EDITION",
      campaignTag: "The Midnight Abduction",
      price: "₹4,999.00",
      priceCents: 499900,
      heroImg: assetUrl("imgi_53_steaks_3_030eee17-f41f-468d-b935-728f2cbc127e.png"),
      hexColor: "#4d235c",
      detailTheme: "theme-steaks",
      discoverLabel: "DISCOVER HIGH STEAKS",
      storyHeadline: "THE MIDNIGHT<br/>ABDUCTION",
      storyText: "An extraterrestrial mystery brought to life. High Steaks captures a whimsical retro-futuristic UFO hovering over midnight farmland, featuring a rotating beam and abducted bovine complication. High horology with an unapologetic sense of humor.",
      storyBadge: "🛸 RETRO-FUTURISTIC COMPLICATION",
      features: [
        { title: "MYSTERY ABDUCTION CALIBER", desc: "Custom automatic complication with rotating levitation beam" },
        { title: "SUPER-LUMINOVA BEAM", desc: "Intense luminous green pigment radiating under low ambient light" },
        { title: "SHOCK-ABSORBING BALANCE", desc: "40-hour escapement protected by Incabloc shock suspension" }
      ],
      macroImg: assetUrl("steaks_macro.png"),
      lifestyleImg: assetUrl("imgi_53_steaks_3_030eee17-f41f-468d-b935-728f2cbc127e.png"),
      wristCaseSize: "40.0MM",
      wristCaseDesc: "(47.0MM Lug-to-Lug)",
      cardVariant: "IN DEEP PURPLE & ONYX",
      gallery: [
        { src: assetUrl("imgi_53_steaks_3_030eee17-f41f-468d-b935-728f2cbc127e.png"), label: "Front Dial", desc: "Front View 1" },
        { src: assetUrl("imgi_53_steaks_3_030eee17-f41f-468d-b935-728f2cbc127e.png"), label: "Perspective Angle", desc: "Angle View 2" },
        { src: assetUrl("imgi_53_steaks_3_030eee17-f41f-468d-b935-728f2cbc127e.png"), label: "Full Profile", desc: "Profile View 3" }
      ],
      specs: [
        ["Movement", "Automatic mystery jumping cow caliber"],
        ["Power Reserve", "40 Hours, shock-absorbing escapement"],
        ["Case Dimensions", "40 mm circular, 316L Mirror-Finished Steel"],
        ["Dial Scene", "Nocturnal farm with luminous tractor beam & abducted cow"],
        ["Water Resistance", "5 bar (~50 metres / 165 feet)"],
        ["Strap", "Premium matte black textured leather strap"]
      ]
    }
  ];

  // 4 Distinct Luxury Watches (Paddock 74 is FIRST)
  const REAL_PRODUCTS = [
    Object.assign({}, BASE_PRODUCTS[0]),
    Object.assign({}, BASE_PRODUCTS[1]),
    Object.assign({}, BASE_PRODUCTS[2]),
    Object.assign({}, BASE_PRODUCTS[3])
  ];

  // Hydrate REAL_PRODUCTS with real Shopify Liquid data from <script id="shopify-showcase-products">
  (function hydrateShopifyProducts() {
    const dataEl = document.getElementById("shopify-showcase-products");
    if (dataEl) {
      try {
        const parsed = JSON.parse(dataEl.textContent);
        if (Array.isArray(parsed) && parsed.length > 0) {
          console.log("[Theme] Hydrating products from Shopify Liquid:", parsed);
          parsed.forEach((sp, idx) => {
            if (idx < REAL_PRODUCTS.length) {
              if (!sp.heroImg) {
                delete sp.heroImg;
              }
              Object.assign(REAL_PRODUCTS[idx], sp);
              if (sp.priceRaw) {
                REAL_PRODUCTS[idx].priceCents = sp.priceRaw;
              }
            } else {
              REAL_PRODUCTS.push(sp);
            }
          });
        }
      } catch (err) {
        console.warn("[Theme] Could not parse shopify-showcase-products:", err);
      }
    }
  })();

  // Dynamically resolve live Shopify variants from /products.json if missing
  async function resolveLiveShopifyVariants() {
    try {
      const res = await fetch('/products.json?limit=30');
      if (res.ok) {
        const data = await res.json();
        if (data && data.products && data.products.length > 0) {
          window.__SHOPIFY_STORE_PRODUCTS = data.products;
          console.log("[Theme] Fetched live catalog /products.json:", data.products);

          REAL_PRODUCTS.forEach((prod, idx) => {
            if (!prod.variantId) {
              const matched = data.products.find(sp => 
                (sp.handle && sp.handle.toLowerCase() === (prod.id || '').toLowerCase()) ||
                (sp.title && prod.title && sp.title.toLowerCase().includes(prod.title.toLowerCase())) ||
                (sp.title && prod.title && prod.title.toLowerCase().includes(sp.title.toLowerCase()))
              ) || data.products[idx % data.products.length];

              if (matched && matched.variants && matched.variants.length > 0) {
                const liveVar = matched.variants[0];
                prod.variantId = liveVar.id;
                if (liveVar.price) {
                  prod.priceCents = Math.round(parseFloat(liveVar.price) * 100);
                  prod.price = formatMoney(prod.priceCents);
                }
                if (matched.images && matched.images.length > 0 && !prod.heroImg) {
                  prod.heroImg = matched.images[0].src;
                }
                console.log(`[Theme] Linked ${prod.title || prod.id} -> Variant ID ${prod.variantId} (${prod.price})`);
              }
            }
          });

          // Re-sync active product price if detail sheet is open
          if (typeof currentLogicalIdx !== 'undefined' && REAL_PRODUCTS[currentLogicalIdx]) {
            const cp = REAL_PRODUCTS[currentLogicalIdx];
            const sheetPriceEl = document.getElementById("sheetPriceVal");
            if (sheetPriceEl) {
              sheetPriceEl.textContent = cp.price || formatMoney(cp.priceCents);
            }
          }

          if (typeof initPeekStrip === 'function') {
            initPeekStrip();
          }
        }
      }
    } catch (e) {
      // Offline preview
    }
  }
  resolveLiveShopifyVariants();

  const NUM_REAL_SLIDES = REAL_PRODUCTS.length;

  const THEME_HEX_MAP = {
    "avocado": "#3d5423",
    "moon": "#1b426b",
    "steaks": "#4d235c",
    "cypher-paddock": "#6a1a24"
  };

  // Strap studio collection
  const STRAP_COLLECTION = [
    { id: "black", name: "Onyx Black Sport", file: "strap5.png", hex: "#2c2c2c", material: "FKM High-Performance Vulcanized Rubber" },
    { id: "orange", name: "Sunset Orange Sport", file: "strap4.png", hex: "#de794e", material: "FKM High-Performance Vulcanized Rubber" },
    { id: "blue", name: "Royal Cobalt Blue", file: "strap1.png", hex: "#1a3a75", material: "FKM High-Performance Vulcanized Rubber" },
    { id: "burgundy", name: "Bordeaux Wine Red", file: "strap2.png", hex: "#4b1e26", material: "FKM High-Performance Vulcanized Rubber" },
    { id: "green", name: "Racing Emerald Green", file: "strap3.png", hex: "#0f3b2b", material: "FKM High-Performance Vulcanized Rubber" }
  ];

  // Simulated wrist sizes
  const WRIST_SIZES = {
    small: { inches: '5 <sup>3/4"</sup>', mm: '(146.05 MM)', scale: 0.82, percent: 10 },
    medium: { inches: '6 <sup>1/4"</sup>', mm: '(158.75 MM)', scale: 0.91, percent: 32 },
    large: { inches: '6 <sup>3/4"</sup>', mm: '(171.45 MM)', scale: 1.0, percent: 56 },
    xlarge: { inches: '7 <sup>3/4"</sup>', mm: '(196.85 MM)', scale: 1.15, percent: 80 },
    notsure: { inches: '6 <sup>3/4"</sup>', mm: '(171.45 MM)', scale: 1.0, percent: 96 }
  };

  // State Variables
  let currentLogicalIdx = 0;
  let isLiquidAnimating = false;
  let bagCount = 0;
  let isWishlisted = false;
  let isNightMode = false;
  let currentGalleryPhotoIdx = 0;
  let currentStrapIdx = 2; // Default Royal Blue

  // Local fallback cart items (for demo / offline mode)
  let fallbackCartItems = [];

  // DOM Elements
  const appViewport = document.getElementById("appViewport");
  const homeIntro = document.getElementById("homeIntro");
  const homeIntroVideo = document.getElementById("homeIntroVideo");
  const homeIntroExplore = document.getElementById("homeIntroExplore");
  const liquidMainPath = document.getElementById("liquidMainPath");
  const liquidCrestPath = document.getElementById("liquidCrestPath");
  const watchHeroCurrent = document.getElementById("watchHeroCurrent");
  const watchHeroIncoming = document.getElementById("watchHeroIncoming");
  const watchInfoColumn = document.getElementById("watchInfoColumn");
  const watchTitle = document.getElementById("watchTitle");
  const campaignTag = document.getElementById("campaignTag");
  const referenceTag = document.getElementById("referenceTag");
  const discoverBtnText = document.getElementById("discoverBtnText");
  const slidePeekStrip = document.getElementById("slidePeekStrip");
  const peekWatchThumbnail = document.getElementById("peekWatchThumbnail");
  const dots = document.querySelectorAll(".dot-indicators .carousel-dot");
  const btnPrevSlide = document.getElementById("btnPrevSlide");
  const btnNextSlide = document.getElementById("btnNextSlide");
  const metaThemeColor = document.getElementById("metaThemeColor");
  const appToast = document.getElementById("appToast");

  if (homeIntro && homeIntroExplore) {
    homeIntroExplore.addEventListener("click", () => {
      try {
        window.localStorage.setItem("ewHomeIntroSeen", "true");
      } catch (error) {
        console.warn("[EW] Could not save the homepage intro preference:", error);
      }
      homeIntro.classList.add("is-leaving");
      homeIntro.setAttribute("aria-hidden", "true");
      if (homeIntroVideo) homeIntroVideo.pause();
      window.setTimeout(() => {
        homeIntro.remove();
        const discoverButton = document.getElementById("btnDiscoverAction");
        if (discoverButton) discoverButton.focus({ preventScroll: true });
      }, 700);
    });
  }

  // Detail Modal Elements
  const detailOverlayView = document.getElementById("detailOverlayView");
  const detailLeftStage = document.getElementById("detailLeftStage");
  const btnCloseDetail = document.getElementById("btnCloseDetail");
  const btnStickyCloseDetail = document.getElementById("btnStickyCloseDetail");
  const detailFrontWatchImg = document.getElementById("detailFrontWatchImg");
  const btnGalleryPrev = document.getElementById("btnGalleryPrev");
  const btnGalleryNext = document.getElementById("btnGalleryNext");
  const galleryCaptionBadge = document.getElementById("galleryCaptionBadge");
  const galleryCurrentIndexText = document.getElementById("galleryCurrentIndexText");
  const galleryCurrentLabelText = document.getElementById("galleryCurrentLabelText");
  const galleryStripItems = document.getElementById("galleryStripItems");
  const sheetTitle = document.getElementById("sheetTitle");
  const sheetSubtitle = document.getElementById("sheetSubtitle");
  const sheetPriceVal = document.getElementById("sheetPriceVal");
  const tableSpecs = document.getElementById("tableSpecs");
  const lumeModeSwitch = document.getElementById("lumeModeSwitch");
  const lumeSun = document.getElementById("lumeSun");
  const lumeMoon = document.getElementById("lumeMoon");
  const btnDetailAddToBag = document.getElementById("btnDetailAddToBag");
  const btnDetailWishlist = document.getElementById("btnDetailWishlist");
  const detailWishlistText = document.getElementById("detailWishlistText");
  const headerBagCount = document.getElementById("headerBagCount");
  const btnHeaderBag = document.getElementById("btnBagTrigger") || document.getElementById("btnHeaderBag");
  const btnWishlistTrigger = document.getElementById("btnWishlistTrigger") || document.getElementById("btnHeaderWishlist");

  // Cart Drawer Elements
  const cartDrawerOverlay = document.getElementById("cartDrawerOverlay");
  const cartDrawerBackdrop = document.getElementById("cartDrawerBackdrop");
  const btnCloseCartDrawer = document.getElementById("btnCloseCartDrawer");
  const btnContinueBrowsing = document.getElementById("btnContinueBrowsing");
  const cartDrawerBody = document.getElementById("cartDrawerBody");
  const cartDrawerCount = document.getElementById("cartDrawerCount");
  const cartSubtotalVal = document.getElementById("cartSubtotalVal");
  const cartDrawerFooter = document.getElementById("cartDrawerFooter");

  // Video Modal Elements
  const videoModalOverlay = document.getElementById("videoModalOverlay");
  const btnCloseVideoModal = document.getElementById("btnCloseVideoModal");
  const embeddedVideo = document.getElementById("embeddedVideo");
  const btnTogglePlayback = document.getElementById("btnTogglePlayback");
  const playbackIcon = document.getElementById("playbackIcon");
  const calibreSeekTrack = document.getElementById("calibreSeekTrack");
  const calibreSeekFill = document.getElementById("calibreSeekFill");
  const calibreTimeLabel = document.getElementById("calibreTimeLabel");
  const btnDetailVideoAction = document.getElementById("btnDetailVideoAction");
  const btnAudioToggle = document.getElementById("btnAudioToggle");

  // Toast System
  function showToast(msg) {
    if (!appToast) return;
    appToast.textContent = msg;
    appToast.classList.add("is-shown");
    setTimeout(() => {
      appToast.classList.remove("is-shown");
    }, 2500);
  }

  // =========================================================================
  // SHOPIFY CART ENGINE (AJAX / Drawer Controller)
  // =========================================================================

  function updateBagBadge(count) {
    const num = Math.max(0, parseInt(count, 10) || 0);
    bagCount = num;
    document.querySelectorAll("#headerBagCount, .action-badge, .bag-badge, .cart-count-badge").forEach(el => {
      if (el.id === "headerBagCount" || el.classList.contains("cart-count-badge") || el.classList.contains("bag-badge") || el.classList.contains("action-badge")) {
        el.textContent = num;
        el.style.display = "inline-flex";
      }
    });
    if (cartDrawerCount) {
      cartDrawerCount.textContent = `(${num})`;
    }
  }

  function openCartDrawer(e) {
    if (e && e.preventDefault) e.preventDefault();
    if (!cartDrawerOverlay) return;
    cartDrawerOverlay.classList.add("is-active");
    refreshCartDrawer();
  }

  function closeCartDrawer(e) {
    if (e && e.preventDefault) e.preventDefault();
    if (!cartDrawerOverlay) return;
    cartDrawerOverlay.classList.remove("is-active");
  }

  document.addEventListener("ew:cart:added", openCartDrawer);

  async function refreshCartDrawer() {
    if (!cartDrawerBody) return;

    try {
      const res = await fetch('/cart.js', {
        headers: { 'Accept': 'application/json' }
      });
      if (res.ok) {
        const cart = await res.json();
        renderShopifyCart(cart);
        return;
      }
    } catch (err) {
      // In local preview without Shopify backend, fallback gracefully
    }
    renderFallbackCart();
  }

  function renderShopifyCart(cart) {
    updateBagBadge(cart.item_count);

    if (cartSubtotalVal) {
      cartSubtotalVal.textContent = formatMoney(cart.total_price);
    }

    if (cart.item_count === 0) {
      renderEmptyCart();
      return;
    }

    let itemsHtml = '<div class="cart-drawer-items" id="cartDrawerItems">';
    cart.items.forEach((item, idx) => {
      const lineNum = idx + 1;
      const imgSrc = item.image || item.featured_image?.url || assetUrl("cypher-paddock.png");
      const priceFormatted = formatMoney(item.final_line_price);
      const variantHtml = (item.variant_title && item.variant_title !== 'Default Title')
        ? `<span class="cart-item-variant">${item.variant_title}</span>`
        : '';

      let propsHtml = '';
      if (item.properties) {
        let propItems = '';
        for (const [key, val] of Object.entries(item.properties)) {
          if (!key.startsWith('_') && val) {
            propItems += `<span class="cart-item-prop"><strong>${key}:</strong> ${val}</span>`;
          }
        }
        if (propItems) {
          propsHtml = `<div class="cart-item-props-wrap">${propItems}</div>`;
        }
      }

      itemsHtml += `
        <div class="cart-drawer-item" data-line-key="${item.key}" data-line="${lineNum}">
          <div class="cart-item-img-frame">
            <img src="${imgSrc}" alt="${item.title}" width="80" height="80" loading="lazy">
          </div>
          <div class="cart-item-info">
            <div class="cart-item-header-row">
              <h4 class="cart-item-name">${item.product_title || item.title}</h4>
              <button class="btn-cart-remove" data-line="${lineNum}" data-key="${item.key}" title="Remove timepiece" type="button">
                <svg viewBox="0 0 24 24"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
              </button>
            </div>
            ${variantHtml}
            ${propsHtml}
            <div class="cart-item-price-row">
              <div class="cart-qty-stepper">
                <button class="btn-cart-qty minus" data-line="${lineNum}" data-key="${item.key}" data-qty="${item.quantity - 1}" type="button" aria-label="Decrease">&minus;</button>
                <span class="cart-qty-val">${item.quantity}</span>
                <button class="btn-cart-qty plus" data-line="${lineNum}" data-key="${item.key}" data-qty="${item.quantity + 1}" type="button" aria-label="Increase">&plus;</button>
              </div>
              <span class="cart-item-price">${priceFormatted}</span>
            </div>
          </div>
        </div>
      `;
    });
    itemsHtml += '</div>';

    cartDrawerBody.innerHTML = itemsHtml;
    if (cartDrawerFooter) cartDrawerFooter.style.display = 'block';

    bindCartEvents();
  }

  function renderFallbackCart() {
    updateBagBadge(fallbackCartItems.reduce((acc, it) => acc + it.quantity, 0));

    if (fallbackCartItems.length === 0) {
      renderEmptyCart();
      if (cartSubtotalVal) cartSubtotalVal.textContent = "₹0.00";
      return;
    }

    const totalCents = fallbackCartItems.reduce((acc, it) => acc + (it.priceCents * it.quantity), 0);
    if (cartSubtotalVal) cartSubtotalVal.textContent = formatMoney(totalCents);

    let itemsHtml = '<div class="cart-drawer-items" id="cartDrawerItems">';
    fallbackCartItems.forEach((item, idx) => {
      const lineNum = idx + 1;
      const priceFormatted = formatMoney(item.priceCents * item.quantity);
      itemsHtml += `
        <div class="cart-drawer-item" data-line="${lineNum}">
          <div class="cart-item-img-frame">
            <img src="${item.img}" alt="${item.title}" width="80" height="80" loading="lazy">
          </div>
          <div class="cart-item-info">
            <div class="cart-item-header-row">
              <h4 class="cart-item-name">${item.title}</h4>
              <button class="btn-cart-remove" data-line="${lineNum}" title="Remove timepiece" type="button">
                <svg viewBox="0 0 24 24"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
              </button>
            </div>
            ${item.reference ? `<span class="cart-item-variant">${item.reference}</span>` : ''}
            <div class="cart-item-props-wrap">
              <span class="cart-item-prop"><strong>Strap:</strong> ${item.strapName}</span>
            </div>
            <div class="cart-item-price-row">
              <div class="cart-qty-stepper">
                <button class="btn-cart-qty minus" data-line="${lineNum}" data-qty="${item.quantity - 1}" type="button" aria-label="Decrease">&minus;</button>
                <span class="cart-qty-val">${item.quantity}</span>
                <button class="btn-cart-qty plus" data-line="${lineNum}" data-qty="${item.quantity + 1}" type="button" aria-label="Increase">&plus;</button>
              </div>
              <span class="cart-item-price">${priceFormatted}</span>
            </div>
          </div>
        </div>
      `;
    });
    itemsHtml += '</div>';

    cartDrawerBody.innerHTML = itemsHtml;
    if (cartDrawerFooter) cartDrawerFooter.style.display = 'block';

    bindCartEvents();
  }

  function renderEmptyCart() {
    if (!cartDrawerBody) return;
    cartDrawerBody.innerHTML = `
      <div class="cart-empty-notice" id="cartEmptyNotice">
        <svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>
        <p>Your shopping bag is currently empty.</p>
        <button class="btn-continue-browsing" id="btnContinueBrowsing" type="button">DISCOVER PIECES</button>
      </div>
    `;
    const btn = document.getElementById("btnContinueBrowsing");
    if (btn) {
      btn.addEventListener("click", () => {
        closeCartDrawer();
      });
    }
  }

  function bindCartEvents() {
    // Quantity Steppers
    cartDrawerBody.querySelectorAll(".btn-cart-qty").forEach(btn => {
      btn.addEventListener("click", async () => {
        const line = parseInt(btn.getAttribute("data-line"), 10);
        const key = btn.getAttribute("data-key");
        const newQty = parseInt(btn.getAttribute("data-qty"), 10);
        await updateCartItemQuantity(key || line, newQty);
      });
    });

    // Remove buttons
    cartDrawerBody.querySelectorAll(".btn-cart-remove").forEach(btn => {
      btn.addEventListener("click", async () => {
        const line = parseInt(btn.getAttribute("data-line"), 10);
        const key = btn.getAttribute("data-key");
        await updateCartItemQuantity(key || line, 0);
      });
    });
  }

  async function updateCartItemQuantity(idOrLine, quantity) {
    try {
      const res = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({
          id: String(idOrLine),
          quantity: Math.max(0, quantity)
        })
      });
      if (res.ok) {
        const cart = await res.json();
        renderShopifyCart(cart);
        return;
      }
    } catch (e) {
      // In fallback mode
    }

    // Fallback cart update
    const lineIdx = Number(idOrLine) - 1;
    if (fallbackCartItems[lineIdx]) {
      if (quantity <= 0) {
        fallbackCartItems.splice(lineIdx, 1);
      } else {
        fallbackCartItems[lineIdx].quantity = quantity;
      }
    }
    renderFallbackCart();
  }

  async function addItemToCart(prod, strap) {
    const strapName = strap ? strap.name : "Royal Cobalt Blue";
    const titleClean = prod ? prod.title.replace(/<[^>]*>/g, "") : "PADDOCK 74 CHRONO";
    const ref = prod ? prod.reference : "REF. CYP-PAD-74";
    const img = prod ? prod.heroImg : assetUrl("cypher-paddock.png");
    const priceCents = prod && prod.priceCents ? prod.priceCents : 997400;

    let variantId = prod && prod.variantId ? prod.variantId : null;

    // If variantId is missing, check cached store products
    if (!variantId && window.__SHOPIFY_STORE_PRODUCTS && window.__SHOPIFY_STORE_PRODUCTS.length > 0) {
      const sp = window.__SHOPIFY_STORE_PRODUCTS.find(p => 
        (p.handle && p.handle.toLowerCase() === (prod?.id || '').toLowerCase()) ||
        (p.title && prod?.title && p.title.toLowerCase().includes(prod.title.toLowerCase())) ||
        (p.title && prod?.title && prod.title.toLowerCase().includes(p.title.toLowerCase()))
      ) || window.__SHOPIFY_STORE_PRODUCTS[0];
      if (sp && sp.variants && sp.variants.length > 0) {
        variantId = sp.variants[0].id;
        if (prod) prod.variantId = variantId;
      }
    }

    // If still missing, query /products.json dynamically right now
    if (!variantId) {
      try {
        const pRes = await fetch('/products.json?limit=5');
        if (pRes.ok) {
          const pData = await pRes.json();
          if (pData && pData.products && pData.products.length > 0) {
            const first = pData.products[0];
            if (first.variants && first.variants.length > 0) {
              variantId = first.variants[0].id;
              if (prod) prod.variantId = variantId;
            }
          }
        }
      } catch (err) {}
    }

    let addedSuccessfullyViaShopify = false;

    // Send to official Shopify Cart API
    if (variantId) {
      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            items: [{
              id: variantId,
              quantity: 1,
              properties: {
                'Edition': ref,
                'Interchangeable Strap': strapName
              }
            }]
          })
        });
        if (res.ok) {
          addedSuccessfullyViaShopify = true;
          const cartItem = await res.json();
          console.log("[Theme] /cart/add.js succeeded:", cartItem);
          await refreshCartDrawer();
        } else {
          console.warn("[Theme] /cart/add.js returned non-ok:", await res.text());
        }
      } catch (err) {
        console.warn("[Theme] /cart/add.js network error:", err);
      }
    }

    if (!addedSuccessfullyViaShopify) {
      // Local preview fallback
      const existing = fallbackCartItems.find(it => it.title === titleClean && it.strapName === strapName);
      if (existing) {
        existing.quantity += 1;
      } else {
        fallbackCartItems.push({
          title: titleClean,
          reference: ref,
          strapName: strapName,
          img: img,
          priceCents: priceCents,
          quantity: 1
        });
      }
      renderFallbackCart();
    }

    showToast(`Added to Bag: ${strapName} edition`);
    openCartDrawer();
  }

  // Hook Header Bag button
  if (btnHeaderBag) {
    btnHeaderBag.addEventListener("click", openCartDrawer);
  }
  if (btnCloseCartDrawer) {
    btnCloseCartDrawer.addEventListener("click", closeCartDrawer);
  }
  if (cartDrawerBackdrop) {
    cartDrawerBackdrop.addEventListener("click", closeCartDrawer);
  }
  if (btnContinueBrowsing) {
    btnContinueBrowsing.addEventListener("click", closeCartDrawer);
  }

  // =========================================================================
  // CAROUSEL & NAVIGATION
  // =========================================================================

  function updateDots(idx) {
    dots.forEach((dot, i) => {
      dot.classList.toggle("active", (i % NUM_REAL_SLIDES) === idx);
    });
  }

  function initPeekStrip() {
    if (!slidePeekStrip || !peekWatchThumbnail) return;
    const nextIdx = (currentLogicalIdx + 1) % NUM_REAL_SLIDES;
    const nextProd = REAL_PRODUCTS[nextIdx];
    if (nextProd) {
      slidePeekStrip.style.backgroundColor = THEME_HEX_MAP[nextProd.id] || nextProd.hexColor || '#3d5423';
      const imgSrc = nextProd.heroImg || assetUrl("imgi_293_Avocado_3.png");
      if (imgSrc) {
        peekWatchThumbnail.src = imgSrc;
        peekWatchThumbnail.style.display = "block";
      }
    }
  }
  initPeekStrip();

  // Easing function for liquid curve
  function easeLiquid(t) {
    return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
  }

  function getWavePathForward(p) {
    const e = easeLiquid(p);
    const baseX = 1000.0 * (1.0 - e);
    const bulge = 320.0 * Math.sin(Math.PI * e);
    const cp1aX = Math.max(0.0, baseX - bulge * 0.55);
    const cp1bX = Math.max(0.0, baseX - bulge * 1.25);
    const midX  = Math.max(0.0, baseX - bulge * 1.2);
    const cp2aX = Math.max(0.0, baseX - bulge * 1.15);
    const cp2bX = Math.max(0.0, baseX - bulge * 0.5);
    return `M 1000,0 L ${baseX.toFixed(1)},0 C ${cp1aX.toFixed(1)},180 ${cp1bX.toFixed(1)},360 ${midX.toFixed(1)},500 C ${cp2aX.toFixed(1)},640 ${cp2bX.toFixed(1)},820 ${baseX.toFixed(1)},1000 L 1000,1000 Z`;
  }

  function getCrestPathForward(p) {
    const e = easeLiquid(Math.min(1.0, p * 1.07));
    const baseX = 1000.0 * (1.0 - e);
    const bulge = 360.0 * Math.sin(Math.PI * e);
    const cp1aX = Math.max(0.0, baseX - bulge * 0.6);
    const cp1bX = Math.max(0.0, baseX - bulge * 1.35);
    const midX  = Math.max(0.0, baseX - bulge * 1.3);
    const cp2aX = Math.max(0.0, baseX - bulge * 1.25);
    const cp2bX = Math.max(0.0, baseX - bulge * 0.55);
    return `M 1000,0 L ${baseX.toFixed(1)},0 C ${cp1aX.toFixed(1)},180 ${cp1bX.toFixed(1)},360 ${midX.toFixed(1)},500 C ${cp2aX.toFixed(1)},640 ${cp2bX.toFixed(1)},820 ${baseX.toFixed(1)},1000 L 1000,1000 Z`;
  }

  function getWavePathBackward(p) {
    const e = easeLiquid(p);
    const baseX = 1000.0 * e;
    const bulge = 320.0 * Math.sin(Math.PI * e);
    const cp1aX = Math.min(1000.0, baseX + bulge * 0.55);
    const cp1bX = Math.min(1000.0, baseX + bulge * 1.25);
    const midX  = Math.min(1000.0, baseX + bulge * 1.2);
    const cp2aX = Math.min(1000.0, baseX + bulge * 1.15);
    const cp2bX = Math.min(1000.0, baseX + bulge * 0.5);
    return `M 0,0 L ${baseX.toFixed(1)},0 C ${cp1aX.toFixed(1)},180 ${cp1bX.toFixed(1)},360 ${midX.toFixed(1)},500 C ${cp2aX.toFixed(1)},640 ${cp2bX.toFixed(1)},820 ${baseX.toFixed(1)},1000 L 0,1000 Z`;
  }

  function getCrestPathBackward(p) {
    const e = easeLiquid(Math.min(1.0, p * 1.07));
    const baseX = 1000.0 * e;
    const bulge = 360.0 * Math.sin(Math.PI * e);
    const cp1aX = Math.min(1000.0, baseX + bulge * 0.6);
    const cp1bX = Math.min(1000.0, baseX + bulge * 1.35);
    const midX  = Math.min(1000.0, baseX + bulge * 1.3);
    const cp2aX = Math.min(1000.0, baseX + bulge * 1.25);
    const cp2bX = Math.min(1000.0, baseX + bulge * 0.55);
    return `M 0,0 L ${baseX.toFixed(1)},0 C ${cp1aX.toFixed(1)},180 ${cp1bX.toFixed(1)},360 ${midX.toFixed(1)},500 C ${cp2aX.toFixed(1)},640 ${cp2bX.toFixed(1)},820 ${baseX.toFixed(1)},1000 L 0,1000 Z`;
  }

  function triggerLiquidTransition(targetIdx, direction = "next") {
    if (isLiquidAnimating || targetIdx === currentLogicalIdx) return;
    isLiquidAnimating = true;

    const targetProd = REAL_PRODUCTS[targetIdx];
    if (!targetProd) {
      isLiquidAnimating = false;
      return;
    }
    const targetHex = THEME_HEX_MAP[targetProd.id] || targetProd.hexColor;

    const transparentWaveMap = {
      "avocado": "rgba(90, 130, 50, 0.28)",
      "moon": "rgba(45, 95, 160, 0.28)",
      "steaks": "rgba(125, 55, 155, 0.28)",
      "cypher-paddock": "rgba(150, 35, 45, 0.28)"
    };

    if (liquidMainPath) liquidMainPath.setAttribute("fill", transparentWaveMap[targetProd.id] || "rgba(255, 255, 255, 0.12)");
    if (liquidCrestPath) liquidCrestPath.setAttribute("fill", "rgba(255, 255, 255, 0.22)");

    if (appViewport) appViewport.style.backgroundColor = targetHex;
    document.body.style.backgroundColor = targetHex;
    if (metaThemeColor) metaThemeColor.setAttribute("content", targetHex);

    if (watchHeroIncoming && watchHeroCurrent) {
      watchHeroIncoming.src = targetProd.heroImg;
      watchHeroIncoming.alt = targetProd.id;
      watchHeroIncoming.classList.remove("hidden");

      if (direction === "next") {
        watchHeroIncoming.className = "watch-hero-image entering-from-right";
        watchHeroCurrent.className = "watch-hero-image leaving-next";
      } else {
        watchHeroIncoming.className = "watch-hero-image entering-from-left";
        watchHeroCurrent.className = "watch-hero-image leaving-prev";
      }

      void watchHeroIncoming.offsetWidth;
      requestAnimationFrame(() => {
        watchHeroIncoming.className = "watch-hero-image in-center";
      });
    }

    if (watchInfoColumn) {
      watchInfoColumn.classList.add("is-liquid-leaving");
      setTimeout(() => {
        if (watchTitle) watchTitle.innerHTML = targetProd.title;
        if (campaignTag) campaignTag.textContent = targetProd.campaignTag;
        if (referenceTag) referenceTag.textContent = targetProd.reference;
        if (discoverBtnText) discoverBtnText.textContent = targetProd.discoverLabel;

        watchInfoColumn.classList.remove("is-liquid-leaving");
        watchInfoColumn.classList.add("is-liquid-entering");
        updateDots(targetIdx);
      }, 300);
    }

    const duration = 850;
    const startTime = performance.now();

    function stepWave(now) {
      const elapsed = now - startTime;
      const progress = Math.min(1.0, elapsed / duration);

      const mainD = direction === "next" ? getWavePathForward(progress) : getWavePathBackward(progress);
      const crestD = direction === "next" ? getCrestPathForward(progress) : getCrestPathBackward(progress);

      if (liquidMainPath) liquidMainPath.setAttribute("d", mainD);
      if (liquidCrestPath) liquidCrestPath.setAttribute("d", crestD);

      if (progress < 1.0) {
        requestAnimationFrame(stepWave);
      } else {
        if (liquidMainPath) liquidMainPath.setAttribute("d", "");
        if (liquidCrestPath) liquidCrestPath.setAttribute("d", "");

        if (watchHeroCurrent && watchHeroIncoming) {
          watchHeroCurrent.src = targetProd.heroImg;
          watchHeroCurrent.alt = targetProd.id;
          watchHeroCurrent.className = "watch-hero-image in-center ambient-floating";
          watchHeroIncoming.className = "watch-hero-image hidden";
        }

        if (watchInfoColumn) watchInfoColumn.classList.remove("is-liquid-entering");

        currentLogicalIdx = targetIdx;

        const nextNextIdx = (currentLogicalIdx + 1) % NUM_REAL_SLIDES;
        const nextNextProd = REAL_PRODUCTS[nextNextIdx];
        if (slidePeekStrip && nextNextProd) {
          slidePeekStrip.style.backgroundColor = THEME_HEX_MAP[nextNextProd.id] || nextNextProd.hexColor || '#3d5423';
          const nextImgSrc = nextNextProd.heroImg || assetUrl("imgi_293_Avocado_3.png");
          if (peekWatchThumbnail && nextImgSrc) {
            peekWatchThumbnail.src = nextImgSrc;
            peekWatchThumbnail.style.display = "block";
          }
        }

        isLiquidAnimating = false;
      }
    }

    requestAnimationFrame(stepWave);
  }

  function nextProduct() {
    const nextIdx = (currentLogicalIdx + 1) % NUM_REAL_SLIDES;
    triggerLiquidTransition(nextIdx, "next");
  }

  function prevProduct() {
    const prevIdx = (currentLogicalIdx - 1 + NUM_REAL_SLIDES) % NUM_REAL_SLIDES;
    triggerLiquidTransition(prevIdx, "prev");
  }

  if (btnNextSlide) btnNextSlide.addEventListener("click", nextProduct);
  if (btnPrevSlide) btnPrevSlide.addEventListener("click", prevProduct);
  if (slidePeekStrip) slidePeekStrip.addEventListener("click", nextProduct);

  dots.forEach(dot => {
    dot.addEventListener("click", () => {
      const targetAttr = dot.getAttribute("data-index");
      if (targetAttr === null) return;
      const target = parseInt(targetAttr, 10);
      if (target === currentLogicalIdx || isNaN(target)) return;
      const dir = target > currentLogicalIdx ? "next" : "prev";
      triggerLiquidTransition(target, dir);
    });
  });

  // Wheel & Trackpad Navigation
  let wheelCooldown = false;
  let wheelTimer = null;
  window.addEventListener("wheel", (e) => {
    if ((detailOverlayView && detailOverlayView.classList.contains("is-open")) ||
        (videoModalOverlay && videoModalOverlay.classList.contains("is-active")) ||
        (cartDrawerOverlay && cartDrawerOverlay.classList.contains("is-active"))) {
      return;
    }
    // Vertical wheel scrolls the page (down to Best Sellers / footer).
    // Only a horizontal-dominant gesture navigates the watch carousel.
    if (Math.abs(e.deltaX) <= Math.abs(e.deltaY)) return;
    const delta = e.deltaX;
    if (Math.abs(delta) < 20) return;

    if (!wheelCooldown && !isLiquidAnimating) {
      wheelCooldown = true;
      if (delta > 0) nextProduct();
      else prevProduct();
    }
    clearTimeout(wheelTimer);
    wheelTimer = setTimeout(() => { wheelCooldown = false; }, 550);
  }, { passive: true });

  // Touch Swipe on Hero
  let touchStartX = 0;
  let touchStartY = 0;
  window.addEventListener("touchstart", (e) => {
    touchStartX = e.touches[0].clientX;
    touchStartY = e.touches[0].clientY;
  }, { passive: true });

  window.addEventListener("touchend", (e) => {
    if ((detailOverlayView && detailOverlayView.classList.contains("is-open")) ||
        (videoModalOverlay && videoModalOverlay.classList.contains("is-active")) ||
        (cartDrawerOverlay && cartDrawerOverlay.classList.contains("is-active"))) {
      return;
    }
    const touchEndX = e.changedTouches[0].clientX;
    const touchEndY = e.changedTouches[0].clientY;
    const dx = touchEndX - touchStartX;
    const dy = touchEndY - touchStartY;
    if (Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > 40) {
      if (dx < 0) nextProduct();
      else prevProduct();
    }
  }, { passive: true });

  // Mouse Drag on Hero
  let mouseStartX = 0;
  let isMouseDown = false;
  window.addEventListener("mousedown", (e) => {
    if (e.target.closest("button") || e.target.closest(".slide-peek-strip") || e.target.closest("a")) return;
    isMouseDown = true;
    mouseStartX = e.clientX;
  });

  window.addEventListener("mouseup", (e) => {
    if (!isMouseDown) return;
    isMouseDown = false;
    const dx = e.clientX - mouseStartX;
    if (Math.abs(dx) > 55) {
      if (dx < 0) nextProduct();
      else prevProduct();
    }
  });

  // =========================================================================
  // MULTI-IMAGE GALLERY CONTROLLER
  // =========================================================================

  function renderGalleryStrip(prod) {
    if (!galleryStripItems || !prod || !prod.gallery) {
      if (galleryStripItems && galleryStripItems.parentElement) galleryStripItems.parentElement.style.display = "none";
      return;
    }
    const hasDistinctPhotos = new Set(prod.gallery.map(p => p.src)).size > 1;
    if (!hasDistinctPhotos) {
      if (galleryStripItems.parentElement) galleryStripItems.parentElement.style.display = "none";
      return;
    }
    if (galleryStripItems.parentElement) galleryStripItems.parentElement.style.display = "block";
    galleryStripItems.innerHTML = prod.gallery.map((photo, idx) => `
      <button class="gallery-thumb-btn ${idx === currentGalleryPhotoIdx ? 'active' : ''}" data-gallery-idx="${idx}" title="${photo.label}" type="button">
        <img src="${photo.src}" alt="${photo.label}" />
      </button>
    `).join("");

    galleryStripItems.querySelectorAll(".gallery-thumb-btn").forEach(btn => {
      btn.addEventListener("click", () => {
        const idx = parseInt(btn.getAttribute("data-gallery-idx"), 10);
        selectGalleryPhoto(idx, true);
      });
    });
  }

  function selectGalleryPhoto(idx, toast = false) {
    const prod = REAL_PRODUCTS[currentLogicalIdx];
    if (!prod || !prod.gallery || prod.gallery.length === 0) return;

    if (idx < 0) idx = prod.gallery.length - 1;
    if (idx >= prod.gallery.length) idx = 0;
    currentGalleryPhotoIdx = idx;

    const photo = prod.gallery[currentGalleryPhotoIdx];

    if (detailFrontWatchImg) {
      detailFrontWatchImg.classList.add("is-switching");
      setTimeout(() => {
        detailFrontWatchImg.src = photo.src;
        detailFrontWatchImg.alt = photo.label;
        detailFrontWatchImg.classList.remove("is-switching");
      }, 140);
    }

    if (galleryCurrentIndexText) {
      galleryCurrentIndexText.textContent = `${currentGalleryPhotoIdx + 1} / ${prod.gallery.length}`;
    }
    if (galleryCurrentLabelText) {
      galleryCurrentLabelText.textContent = photo.label.toUpperCase();
    }

    if (galleryStripItems) {
      galleryStripItems.querySelectorAll(".gallery-thumb-btn").forEach((btn, i) => {
        btn.classList.toggle("active", i === currentGalleryPhotoIdx);
      });
    }

    if (toast) {
      showToast(`View: ${photo.label}`);
    }
  }

  if (btnGalleryPrev) {
    btnGalleryPrev.addEventListener("click", () => selectGalleryPhoto(currentGalleryPhotoIdx - 1));
  }
  if (btnGalleryNext) {
    btnGalleryNext.addEventListener("click", () => selectGalleryPhoto(currentGalleryPhotoIdx + 1));
  }

  // =========================================================================
  // SIMULATED FIT SECTION CONTROLLER
  // =========================================================================

  function setSimulatedSize(sizeKey) {
    const data = WRIST_SIZES[sizeKey];
    if (!data) return;

    if (sizeKey === 'notsure') {
      showToast("Sizing Tip: Wrap a tape or strip of paper around your wrist to check your size.");
    }

    document.querySelectorAll(".sim-size-btn").forEach(btn => {
      btn.classList.toggle("active", btn.getAttribute("data-size") === sizeKey);
    });

    document.querySelectorAll(".ruler-station").forEach(st => {
      st.classList.toggle("active", st.getAttribute("data-target") === sizeKey);
    });

    const pin = document.getElementById("rulerTargetIndicator") || document.getElementById("simCaliperPin");
    if (pin) pin.style.left = `${data.percent}%`;

    const inchesEl = document.getElementById("wristMetricInches");
    const mmEl = document.getElementById("wristMetricMm");
    if (inchesEl) inchesEl.innerHTML = data.inches;
    if (mmEl) mmEl.textContent = data.mm;

    const arm = document.getElementById("simWristArmWrapper") || document.getElementById("simArmWrap");
    if (arm) {
      arm.style.transform = `translate(-50%, -50%) scaleY(${data.scale})`;
    }
  }

  document.querySelectorAll(".sim-size-btn").forEach(btn => {
    btn.addEventListener("click", () => {
      const size = btn.getAttribute("data-size");
      if (size) setSimulatedSize(size);
    });
  });

  document.querySelectorAll(".ruler-station").forEach(st => {
    st.addEventListener("click", () => {
      const target = st.getAttribute("data-target");
      if (target) setSimulatedSize(target);
    });
  });

  // Simulated fit CTA buttons
  const btnSimAddCart = document.getElementById("btnSimAddCart");
  if (btnSimAddCart) {
    btnSimAddCart.addEventListener("click", () => {
      const prod = REAL_PRODUCTS[currentLogicalIdx];
      const strap = STRAP_COLLECTION[currentStrapIdx];
      addItemToCart(prod, strap);
    });
  }

  const btnSimWishlist = document.getElementById("btnSimWishlist");
  if (btnSimWishlist) {
    btnSimWishlist.addEventListener("click", () => {
      if (btnDetailWishlist) btnDetailWishlist.click();
    });
  }

  // Quick Action Links in The Story section
  const btnQuickUserManual = document.getElementById("btnQuickUserManual");
  if (btnQuickUserManual) {
    btnQuickUserManual.addEventListener("click", () => {
      showToast("Opening Caliber Maintenance & Crown Setting Guide");
    });
  }

  const btnQuickFullSpecs = document.getElementById("btnQuickFullSpecs");
  if (btnQuickFullSpecs) {
    btnQuickFullSpecs.addEventListener("click", () => {
      const specs = document.getElementById("tableSpecs");
      if (specs) specs.scrollIntoView({ behavior: "smooth", block: "center" });
    });
  }

  const btnQuickSizeGuide = document.getElementById("btnQuickSizeGuide");
  if (btnQuickSizeGuide) {
    btnQuickSizeGuide.addEventListener("click", () => {
      const section = document.getElementById("detailSimulatedFitSection");
      if (section) section.scrollIntoView({ behavior: "smooth" });
    });
  }

  const btnQuickWaterRating = document.getElementById("btnQuickWaterRating");
  if (btnQuickWaterRating) {
    btnQuickWaterRating.addEventListener("click", () => {
      const prod = REAL_PRODUCTS[currentLogicalIdx];
      const waterSpec = prod && prod.specs ? prod.specs.find(s => s[0].toLowerCase().includes("water")) : null;
      showToast(`Water Resistance: ${waterSpec ? waterSpec[1] : '10 Bar (100M / 330FT)'}`);
    });
  }

  // =========================================================================
  // DETAIL MODAL CONTROLLER ("DISCOVER" click)
  // =========================================================================

  function openProductDetail() {
    if (!detailOverlayView) return;
    const prod = REAL_PRODUCTS[currentLogicalIdx];
    if (!prod) return;

    currentGalleryPhotoIdx = 0;
    detailOverlayView.scrollTop = 0;

    if (sheetTitle) sheetTitle.innerHTML = prod.title;
    if (sheetSubtitle) sheetSubtitle.textContent = prod.reference;
    if (sheetPriceVal) sheetPriceVal.textContent = prod.price;

    renderGalleryStrip(prod);
    selectGalleryPhoto(0, false);

    if (detailLeftStage) {
      detailLeftStage.className = "detail-left-stage " + prod.detailTheme;
      detailLeftStage.style.backgroundColor = prod.hexColor || "";
      if (isNightMode) detailLeftStage.classList.add("night-mode");
    }

    const isStrapProduct = String(prod.kind || "normal").toLowerCase() === "strap";
    detailOverlayView.setAttribute("data-ew-kind", isStrapProduct ? "strap" : "normal");
    const strapCard = detailOverlayView.querySelector(".sheet-strap-customizer-card");
    const stageTabs = document.getElementById("stageViewTabs");
    if (strapCard) strapCard.classList.toggle("ew-hidden", !isStrapProduct);
    if (stageTabs) stageTabs.classList.toggle("ew-hidden", !isStrapProduct);

    const colorVariants = Array.isArray(prod.colorVariants) ? prod.colorVariants : [];
    const colorVariantBox = document.getElementById("productColorVariants");
    const colorVariantList = document.getElementById("productColorVariantsList");
    if (colorVariantBox && colorVariantList) {
      colorVariantList.replaceChildren();
      colorVariants.forEach((variant) => {
        if (!variant || !variant.url) return;
        const link = document.createElement("a");
        link.className = "product-color-variant" + (variant.handle === prod.id ? " is-selected" : "");
        link.href = variant.url;
        link.title = variant.title || "";
        link.setAttribute("aria-label", (variant.title || "Product color") +
          (variant.handle === prod.id ? " (selected)" : ""));
        if (variant.handle === prod.id) link.setAttribute("aria-current", "page");

        if (variant.image) {
          const image = document.createElement("img");
          image.src = variant.image;
          image.alt = "";
          image.width = 160;
          image.height = 110;
          image.loading = "lazy";
          link.appendChild(image);
        } else {
          const placeholder = document.createElement("span");
          placeholder.className = "product-color-variant-placeholder";
          placeholder.textContent = (variant.title || "?").slice(0, 1);
          link.appendChild(placeholder);
        }

        const title = document.createElement("span");
        title.className = "product-color-variant-title";
        title.textContent = variant.title || "";
        link.appendChild(title);
        colorVariantList.appendChild(link);
      });
      colorVariantBox.classList.toggle("ew-hidden", colorVariantList.children.length < 2);
    }

    if (tableSpecs && prod.specs) {
      tableSpecs.innerHTML = prod.specs.map(([lbl, val]) => `
        <tr><td>${lbl}</td><td>${val}</td></tr>
      `).join("");
    }

    // 1. Cinematic Banner
    const cinematicBackdrop = document.getElementById("cinematicBackdropImg");
    if (cinematicBackdrop) {
      cinematicBackdrop.style.backgroundImage = `url('${prod.lifestyleImg || prod.macroImg}')`;
    }

    // 2. Story & Features
    const storyHeadline = document.getElementById("storyHeadline");
    if (storyHeadline && prod.storyHeadline) storyHeadline.innerHTML = prod.storyHeadline;

    const storyBodyText = document.getElementById("storyBodyText");
    if (storyBodyText && prod.storyText) storyBodyText.textContent = prod.storyText;

    const storyBadgeLabel = document.getElementById("storyBadgeLabel");
    if (storyBadgeLabel && prod.storyBadge) storyBadgeLabel.textContent = prod.storyBadge;

    const featuresList = document.getElementById("featuresList");
    if (featuresList && prod.features) {
      featuresList.innerHTML = prod.features.map(f => `
        <div class="feature-item">
          <h4 class="feature-item-title">${f.title}</h4>
          <p class="feature-item-desc">${f.desc}</p>
        </div>
      `).join("");
    }

    const storyMacroImg = document.getElementById("storyMacroImg");
    if (storyMacroImg && prod.macroImg) storyMacroImg.src = prod.macroImg;

    // 3. Simulated Fit Section
    const simWatchImg = document.getElementById("simWatchImg");
    if (simWatchImg) simWatchImg.src = prod.dialImg || prod.heroImg;

    const simRulerEyebrow = document.getElementById("simRulerEyebrow");
    if (simRulerEyebrow) simRulerEyebrow.textContent = `SUGGESTED RANGE FOR ${prod.wristCaseSize || '41MM'} CASE`;

    const caseMetricDiameter = document.getElementById("caseMetricDiameter");
    if (caseMetricDiameter) caseMetricDiameter.textContent = prod.wristCaseSize || "41.0MM";

    const caseMetricDesc = document.getElementById("caseMetricDesc");
    if (caseMetricDesc) caseMetricDesc.textContent = prod.wristCaseDesc || "(Case Diameter)";

    const simCardTitle = document.getElementById("simCardTitle");
    if (simCardTitle) simCardTitle.textContent = prod.title.replace(/<[^>]*>/g, "");

    const simCardVariant = document.getElementById("simCardVariant");
    if (simCardVariant) simCardVariant.textContent = prod.cardVariant || "EXCLUSIVE EDITION";

    const simCardWatchImg = document.getElementById("simCardWatchImg");
    if (simCardWatchImg) simCardWatchImg.src = prod.heroImg;

    const simCardPrice = document.getElementById("simCardPrice");
    if (simCardPrice) simCardPrice.textContent = prod.price;

    setSimulatedSize('large');

    // Update strap positions
    setTimeout(() => {
      updateStrapStudioPosition(false);
    }, 60);

    document.body.classList.add("detail-view-open");
    detailOverlayView.classList.add("is-open");

    // Reflect the open product in the address bar (shareable + back-button support).
    const detailHandle = prod.id || prod.handle;
    if (detailHandle && !(history.state && history.state.ewDetail)) {
      try {
        history.pushState({ ewDetail: true, handle: detailHandle }, "", "/products/" + detailHandle);
      } catch (err) { /* history API unavailable */ }
    }
  }

  // Remember the URL the homepage was loaded with, to restore on close.
  const ewHomeUrl = window.location.pathname + window.location.search + window.location.hash;

  function closeDetailOverlay() {
    document.body.classList.remove("detail-view-open");
    if (detailOverlayView) detailOverlayView.classList.remove("is-open");
  }

  // Close + restore the URL. Uses the back button when we pushed a detail state,
  // so browser history stays clean; otherwise just rewrites the URL.
  function requestCloseDetail() {
    if (history.state && history.state.ewDetail) {
      history.back();
    } else {
      closeDetailOverlay();
      try { history.replaceState(null, "", ewHomeUrl); } catch (err) {}
    }
  }

  // Browser back/forward: close the overlay when leaving a detail state.
  window.addEventListener("popstate", () => {
    if (detailOverlayView && detailOverlayView.classList.contains("is-open")) {
      closeDetailOverlay();
    }
  });

  const btnDiscoverAction = document.getElementById("btnDiscoverAction");
  if (btnDiscoverAction) btnDiscoverAction.addEventListener("click", openProductDetail);
  if (watchHeroCurrent) watchHeroCurrent.addEventListener("click", openProductDetail);

  if (btnCloseDetail) {
    btnCloseDetail.addEventListener("click", requestCloseDetail);
  }
  if (btnStickyCloseDetail) {
    btnStickyCloseDetail.addEventListener("click", requestCloseDetail);
  }

  // Day / Night Lume Toggle
  if (lumeModeSwitch) {
    lumeModeSwitch.addEventListener("click", () => {
      isNightMode = !isNightMode;
      if (detailLeftStage) detailLeftStage.classList.toggle("night-mode", isNightMode);
      lumeModeSwitch.classList.toggle("is-night", isNightMode);
      if (lumeSun) lumeSun.classList.toggle("active", !isNightMode);
      if (lumeMoon) lumeMoon.classList.toggle("active", isNightMode);
      showToast(isNightMode ? "Super-LumiNova Glow Activated" : "Daylight Mode Activated");
    });
  }

  // Add to Bag CTA in Detail Sheet
  if (btnDetailAddToBag) {
    btnDetailAddToBag.addEventListener("click", () => {
      const prod = REAL_PRODUCTS[currentLogicalIdx];
      const strap = STRAP_COLLECTION[currentStrapIdx];
      btnDetailAddToBag.textContent = "Added to Bag ✓";
      btnDetailAddToBag.style.background = "#111113";
      btnDetailAddToBag.style.color = "#ffffff";

      addItemToCart(prod, strap);

      setTimeout(() => {
        btnDetailAddToBag.textContent = "Add to Bag";
        btnDetailAddToBag.style.background = "";
        btnDetailAddToBag.style.color = "";
      }, 2000);
    });
  }

  // Wishlist Toggle
  if (btnDetailWishlist) {
    btnDetailWishlist.addEventListener("click", () => {
      isWishlisted = !isWishlisted;
      btnDetailWishlist.classList.toggle("favorited", isWishlisted);
      if (detailWishlistText) detailWishlistText.textContent = isWishlisted ? "In Wishlist ✓" : "Add to wishlist";
      showToast(isWishlisted ? "Saved to your Wishlist" : "Removed from Wishlist");
    });
  }

  // =========================================================================
  // INTERCHANGEABLE STRAP STUDIO LOGIC
  // =========================================================================

  function getSheetItemWidth() {
    if (window.innerWidth <= 380) return 82;
    if (window.innerWidth <= 820) return 95;
    return 135;
  }

  function getLargeItemWidth() {
    if (window.innerWidth <= 820) return 140;
    return 200;
  }

  function updateStrapStudioPosition(animate = true) {
    const itemWidthSheet = getSheetItemWidth();
    const itemWidthLarge = getLargeItemWidth();

    const trackSheet = document.getElementById("strapsSliderTrack");
    if (trackSheet) {
      const offsetSheet = -(currentStrapIdx * itemWidthSheet + itemWidthSheet / 2);
      trackSheet.style.transition = animate ? "transform 0.55s cubic-bezier(0.22, 1, 0.36, 1)" : "none";
      trackSheet.style.transform = `translate3d(${offsetSheet}px, 0, 0)`;
    }

    const trackLarge = document.getElementById("largeStrapsSliderTrack");
    if (trackLarge) {
      const offsetLarge = -(currentStrapIdx * itemWidthLarge + itemWidthLarge / 2);
      trackLarge.style.transition = animate ? "transform 0.55s cubic-bezier(0.22, 1, 0.36, 1)" : "none";
      trackLarge.style.transform = `translate3d(${offsetLarge}px, 0, 0)`;
    }

    document.querySelectorAll(".strap-item-card").forEach((card, idx) => {
      card.classList.toggle("active", idx === currentStrapIdx);
    });
    document.querySelectorAll(".large-strap-item").forEach((card, idx) => {
      card.classList.toggle("active", idx === currentStrapIdx);
    });

    document.querySelectorAll(".strap-swatch-btn").forEach((btn, idx) => {
      btn.classList.toggle("active", idx === currentStrapIdx);
    });

    const strap = STRAP_COLLECTION[currentStrapIdx];
    const badge = document.getElementById("selectedStrapNameBadge");
    if (badge && strap) badge.textContent = strap.name;

    const strapRow = document.querySelector("#tableSpecs tr:last-child td:last-child");
    if (strapRow && strap) {
      strapRow.textContent = `${strap.name} (${strap.material} with quick-release push pins)`;
    }
  }

  function selectStrap(index, toast = true) {
    if (index < 0) index = 0;
    if (index >= STRAP_COLLECTION.length) index = STRAP_COLLECTION.length - 1;
    currentStrapIdx = index;
    updateStrapStudioPosition(true);
    if (toast && STRAP_COLLECTION[currentStrapIdx]) {
      showToast(`Strap Selected: ${STRAP_COLLECTION[currentStrapIdx].name}`);
    }
  }

  const btnStrapPrev = document.getElementById("btnStrapPrev");
  const btnStrapNext = document.getElementById("btnStrapNext");
  if (btnStrapPrev) btnStrapPrev.addEventListener("click", () => selectStrap(currentStrapIdx - 1));
  if (btnStrapNext) btnStrapNext.addEventListener("click", () => selectStrap(currentStrapIdx + 1));

  const btnLargeStrapPrev = document.getElementById("btnLargeStrapPrev");
  const btnLargeStrapNext = document.getElementById("btnLargeStrapNext");
  if (btnLargeStrapPrev) btnLargeStrapPrev.addEventListener("click", () => selectStrap(currentStrapIdx - 1));
  if (btnLargeStrapNext) btnLargeStrapNext.addEventListener("click", () => selectStrap(currentStrapIdx + 1));

  document.querySelectorAll(".strap-swatch-btn").forEach(btn => {
    btn.addEventListener("click", () => {
      const idx = parseInt(btn.getAttribute("data-strap-idx"), 10);
      if (!isNaN(idx)) selectStrap(idx);
    });
  });

  document.querySelectorAll(".strap-item-card").forEach(card => {
    card.addEventListener("click", () => {
      const idx = parseInt(card.getAttribute("data-strap-idx"), 10);
      if (!isNaN(idx)) selectStrap(idx);
    });
  });

  document.querySelectorAll(".large-strap-item").forEach(card => {
    card.addEventListener("click", () => {
      const idx = parseInt(card.getAttribute("data-strap-idx"), 10);
      if (!isNaN(idx)) selectStrap(idx);
    });
  });

  // Stage View Tabs (Timepiece vs Strap Studio)
  const tabTimepieceView = document.getElementById("tabTimepieceView");
  const tabStrapStudioView = document.getElementById("tabStrapStudioView");
  const largeStrapStudioStage = document.getElementById("largeStrapStudioStage");
  const lumeAura = document.getElementById("lumeAura");

  if (tabTimepieceView && tabStrapStudioView) {
    tabTimepieceView.addEventListener("click", () => {
      tabTimepieceView.classList.add("active");
      tabStrapStudioView.classList.remove("active");
      if (detailFrontWatchImg) detailFrontWatchImg.style.display = "block";
      if (lumeAura) lumeAura.style.display = "block";
      if (largeStrapStudioStage) largeStrapStudioStage.style.display = "none";
    });

    tabStrapStudioView.addEventListener("click", () => {
      tabStrapStudioView.classList.add("active");
      tabTimepieceView.classList.remove("active");
      if (detailFrontWatchImg) detailFrontWatchImg.style.display = "none";
      if (lumeAura) lumeAura.style.display = "none";
      if (largeStrapStudioStage) {
        largeStrapStudioStage.style.display = "flex";
        updateStrapStudioPosition(false);
      }
    });
  }

  // Specifications Accordions
  document.querySelectorAll(".sheet-accordion-trigger").forEach(trigger => {
    trigger.addEventListener("click", () => {
      const item = trigger.parentElement;
      if (!item) return;
      const isOpen = item.classList.contains("open");
      document.querySelectorAll(".sheet-accordion-item").forEach(other => {
        if (other !== item) other.classList.remove("open");
      });
      item.classList.toggle("open", !isOpen);
    });
  });

  // =========================================================================
  // FAQ ACCORDION CONTROLLER
  // =========================================================================
  document.querySelectorAll(".faq-trigger").forEach(trigger => {
    trigger.addEventListener("click", () => {
      const item = trigger.closest(".faq-item");
      if (!item) return;
      const isOpen = item.classList.contains("is-open");

      document.querySelectorAll(".faq-item").forEach(other => {
        if (other !== item) {
          other.classList.remove("is-open");
          const otherBtn = other.querySelector(".faq-trigger");
          if (otherBtn) otherBtn.setAttribute("aria-expanded", "false");
        }
      });

      item.classList.toggle("is-open", !isOpen);
      trigger.setAttribute("aria-expanded", !isOpen ? "true" : "false");
    });
  });

  // =========================================================================
  // LUXURY VIDEO MODAL
  // =========================================================================
  function openVideoModal(videoUrl) {
    if (!videoModalOverlay) return;
    videoModalOverlay.classList.add("is-active");
    if (embeddedVideo) {
      if (videoUrl) {
        embeddedVideo.src = videoUrl;
        embeddedVideo.dataset.productVideo = "true";
        embeddedVideo.load();
      }
      embeddedVideo.currentTime = 0;
      embeddedVideo.play().catch(() => {});
    }
    updatePlayIcon(true);
  }

  function closeVideoModal() {
    if (!videoModalOverlay) return;
    videoModalOverlay.classList.remove("is-active");
    if (embeddedVideo) {
      embeddedVideo.pause();
      if (embeddedVideo.dataset.productVideo === "true") {
        embeddedVideo.removeAttribute("src");
        delete embeddedVideo.dataset.productVideo;
        embeddedVideo.load();
      }
    }
    updatePlayIcon(false);
  }

  function updatePlayIcon(isPlaying) {
    if (!playbackIcon) return;
    if (isPlaying) {
      playbackIcon.innerHTML = '<rect x="6" y="4" width="4" height="16"/><rect x="14" y="4" width="4" height="16"/>';
    } else {
      playbackIcon.innerHTML = '<path d="M8 5v14l11-7z"/>';
    }
  }

  const campaignVideoBtn = document.getElementById("campaignVideoBtn");
  if (campaignVideoBtn) {
    campaignVideoBtn.addEventListener("click", () => {
      const product = REAL_PRODUCTS[currentLogicalIdx];
      openVideoModal(product && product.film);
    });
  }

  const btnPlayCinematic = document.getElementById("btnPlayCinematic");
  if (btnPlayCinematic) btnPlayCinematic.addEventListener("click", openVideoModal);

  if (btnCloseVideoModal) btnCloseVideoModal.addEventListener("click", closeVideoModal);
  if (btnDetailVideoAction) btnDetailVideoAction.addEventListener("click", openVideoModal);

  if (btnTogglePlayback && embeddedVideo) {
    btnTogglePlayback.addEventListener("click", () => {
      if (embeddedVideo.paused) {
        embeddedVideo.play();
        updatePlayIcon(true);
      } else {
        embeddedVideo.pause();
        updatePlayIcon(false);
      }
    });
  }

  if (embeddedVideo) {
    embeddedVideo.addEventListener("timeupdate", () => {
      if (!embeddedVideo.duration || !calibreSeekFill) return;
      const progress = (embeddedVideo.currentTime / embeddedVideo.duration) * 100;
      calibreSeekFill.style.width = progress + "%";

      if (calibreTimeLabel) {
        const curSec = Math.floor(embeddedVideo.currentTime);
        const min = String(Math.floor(curSec / 60)).padStart(2, "0");
        const sec = String(curSec % 60).padStart(2, "0");
        calibreTimeLabel.textContent = `${min}:${sec}`;
      }
    });

    embeddedVideo.addEventListener("ended", () => {
      updatePlayIcon(false);
    });
  }

  if (calibreSeekTrack && embeddedVideo) {
    calibreSeekTrack.addEventListener("click", (e) => {
      const rect = calibreSeekTrack.getBoundingClientRect();
      const clickX = e.clientX - rect.left;
      const pct = clickX / rect.width;
      if (embeddedVideo.duration) {
        embeddedVideo.currentTime = pct * embeddedVideo.duration;
      }
    });
  }

  if (btnAudioToggle && embeddedVideo) {
    btnAudioToggle.addEventListener("click", () => {
      embeddedVideo.muted = !embeddedVideo.muted;
      showToast(embeddedVideo.muted ? "Audio Muted" : "Audio Enabled");
    });
  }

  // Keyboard Navigation
  window.addEventListener("keydown", (e) => {
    if (e.key === "Escape") {
      if (cartDrawerOverlay && cartDrawerOverlay.classList.contains("is-active")) {
        closeCartDrawer();
      } else if (videoModalOverlay && videoModalOverlay.classList.contains("is-active")) {
        closeVideoModal();
      } else if (detailOverlayView && detailOverlayView.classList.contains("is-open")) {
        requestCloseDetail();
      }
    } else if (e.key === "ArrowRight") {
      if (detailOverlayView && detailOverlayView.classList.contains("is-open")) {
        if (!tabStrapStudioView || !tabStrapStudioView.classList.contains("active")) {
          selectGalleryPhoto(currentGalleryPhotoIdx + 1);
        }
      } else if (!videoModalOverlay || !videoModalOverlay.classList.contains("is-active")) {
        nextProduct();
      }
    } else if (e.key === "ArrowLeft") {
      if (detailOverlayView && detailOverlayView.classList.contains("is-open")) {
        if (!tabStrapStudioView || !tabStrapStudioView.classList.contains("active")) {
          selectGalleryPhoto(currentGalleryPhotoIdx - 1);
        }
      } else if (!videoModalOverlay || !videoModalOverlay.classList.contains("is-active")) {
        prevProduct();
      }
    } else if (e.code === "Space" && videoModalOverlay && videoModalOverlay.classList.contains("is-active")) {
      e.preventDefault();
      if (btnTogglePlayback) btnTogglePlayback.click();
    }
  });

  // Mobile Menu Toggle
  const mobileMenuBtn = document.getElementById("mobileMenuBtn");
  const mainNavMenu = document.getElementById("mainNavMenu");
  if (mobileMenuBtn && mainNavMenu) {
    mobileMenuBtn.addEventListener("click", () => {
      mobileMenuBtn.classList.toggle("is-active");
      mainNavMenu.classList.toggle("mobile-open");
    });
    mainNavMenu.querySelectorAll(".nav-link").forEach(link => {
      link.addEventListener("click", () => {
        mobileMenuBtn.classList.remove("is-active");
        mainNavMenu.classList.remove("mobile-open");
      });
    });
  }

  // Window Resize
  window.addEventListener("resize", () => {
    updateStrapStudioPosition(false);
  });

  // Initial cart sync on load
  refreshCartDrawer();

})();